import {
  dichCung, ngayThangNam, ngayThangNamCanChi, nguHanh,
  thienCan, timCoThan, timCuc, timHoaLinh, diaChi,
  timLuuTru, timPhaToai, timThienKhoi, timThienMa,
  timThienQuanThienPhuc, timTrangSinh, timTriet, timTuVi
} from './amduong'
import {
  saoAnQuang,
  saoBachHo,
  saoBacSy,
  saoBatToa,
  saoBenh,
  saoBenhPhu,
  saoCoThan,
  saoCuMon,
  saoDaiHao,
  saoDaLa,
  saoDaoHoa,
  saoDauQuan,
  saoDeVuong,
  saoDiaGiai,
  saoDiaKhong,
  saoDiaKiep,
  saoDiaVong,
  saoDieuKhach,
  saoDuong,
  saoDuongPhu, saoDvBachHo,
  saoDvDaLa,
  saoDvHoaKhoa,
  saoDvHoaKy,
  saoDvHoaLoc,
  saoDvHoaQuyen,
  saoDvKinhDuong,
  saoDvLocTon, saoDvTangMon, saoDvThaiTue, saoDvThienHu, saoDvThienKhoc, saoDvThienKhoi, saoDvThienMa,
  saoDvThienViet,
  saoGiaiThan,
  saoHoaCai,
  saoHoaKhoa,
  saoHoaKy,
  saoHoaLoc,
  saoHoaQuyen,
  saoHoaTinh,
  saoHongLoan,
  saoHuuBat,
  saoHyThan,
  saoKiepSat,
  saoKinhDuong,
  saoLamQuan,
  saoLiemTrinh,
  saoLinhTinh,
  saoLocTon,
  saoLongDuc,
  saoLongTri,
  saoLucSi,
  saoLuuBachHo,
  saoLuuDaLa,
  saoLuuHa,
  saoLuuHoaKhoa,
  saoLuuHoaKy,
  saoLuuHoaLoc,
  saoLuuHoaQuyen,
  saoLuuKinhDuong,
  saoLuuLocTon,
  saoLuuTangMon,
  saoLuuThaiTue,
  saoLuuThienHu,
  saoLuuThienKhoc,
  saoLuuThienKhoi,
  saoLuuThienMa,
  saoLuuThienViet,
  saoMo,
  saoMocDuc,
  saoNguyetDuc,
  saoPhaQuan,
  saoPhaToai,
  saoPhiLiem,
  saoPhongCao,
  saoPhucBinh,
  saoPhucDuc,
  saoPhuongCac,
  saoQuanDoi,
  saoQuanPhu2,
  saoQuanPhu3,
  saoQuaTu,
  saoQuocAn,
  saoSuy,
  saoTamThai,
  saoTangMon,
  saoTaPhu,
  saoTauThu,
  saoThai,
  saoThaiAm,
  saoThaiDuong,
  saoThaiPhu,
  saoThaiTue,
  saoThamLang,
  saoThanhLong,
  saoThatSat,
  saoThienCo,
  saoThienDong,
  saoThienDuc,
  saoThienGiai,
  saoThienHinh,
  saoThienHu,
  saoThienHy,
  saoThienKhoc,
  saoThienKhoi,
  saoThienKhong,
  saoThienLa,
  saoThienLuong,
  saoThienMa,
  saoThienPhu,
  saoThienPhuc,
  saoThienQuan,
  saoThienQuy,
  saoThienRieu,
  saoThienSu,
  saoThienTai,
  saoThienTho,
  saoThienThuong,
  saoThienTru,
  saoThienTuong,
  saoThienViet,
  saoThienY,
  saoThieuAm,
  saoThieuDuong,
  saoTieuHao,
  saoTrangSinh,
  saoTrucPhu,
  saoTu,
  saoTuePha,
  saoTuongQuan,
  saoTuPhu,
  saoTuVi,
  saoTuyet,
  saoVanKhuc,
  saoVanTinh,
  saoVanXuong,
  saoVuKhuc
} from './sao'

import { DiaBan } from './diaban'
import { CAN, CHI, getYearCanChi } from '../calender'

export const lapDiaBan = (dd, mm, yyyy, gioSinh, gioiTinh, namXem, tuHoaDv, tuHoaTv) => {
  const { day, month, year } = ngayThangNam(dd, mm, yyyy)
  const canchi = ngayThangNamCanChi(dd, mm, yyyy)
  const chiThang = canchi[1]
  const canNam = canchi[2]
  const chiNam = canchi[3]

  const namXem2 = tuHoaTv ? Number(tuHoaTv.split('_')[0]) : namXem
  const canchiNamXem = ngayThangNamCanChi(15, 8, namXem2)
  const canNamXem = canchiNamXem[2]
  const chiNamXem = canchiNamXem[3]

  const curTuoi = namXem2 - year + 1

  var diaBan = new DiaBan(month, gioSinh, canchiNamXem, curTuoi, namXem2, tuHoaDv)

  const amDuongNamSinh = thienCan[canNam].amDuong
  const amDuongChiNamSinh = diaChi[chiNam].amDuong

  // Bản Mệnh chính là Ngũ hành nạp âm của năm sinh
  // const banMenh = nguHanhNapAm(canNam, chiNam)

  const hanhCuc = timCuc(diaBan.cungMenh, canNam)
  const cuc = nguHanh(hanhCuc)
  const cucSo = cuc.cuc

  // Nhập đại hạn khi đã biết được số cục
  // Theo sách Số tử vi dưới góc nhìn khoa học
  // Dương Nam - Âm Nữ theo chiều thuận
  // Âm Nam - Dương Nữ theo chiều nghịch
  diaBan = diaBan.nhapDaiHan(cucSo, gioiTinh * amDuongChiNamSinh)

  // Nhập tiểu hạn
  const khoiHan = dichCung(11, [-3 * (chiNam - 1)])
  diaBan = diaBan.nhapTieuHan(khoiHan, gioiTinh, chiNam)

  // Nhập tháng hạn
  diaBan = diaBan.nhapThangHan(khoiHan, gioiTinh, chiNam, chiNamXem, chiThang, gioSinh)

  // Nhập can cung
  diaBan = diaBan.nhapCungCan(canNam)

  // Bắt đầu an Tử vi tinh hệ
  const viTriTuVi = timTuVi(cucSo, day)
  diaBan.nhapSao(diaBan, viTriTuVi, saoTuVi)

  const viTriLiemTrinh = dichCung(viTriTuVi, [4])
  diaBan.nhapSao(diaBan, viTriLiemTrinh, saoLiemTrinh)

  const viTriThienDong = dichCung(viTriTuVi, [7])
  diaBan.nhapSao(diaBan, viTriThienDong, saoThienDong)

  const viTriVuKhuc = dichCung(viTriTuVi, [8])
  diaBan.nhapSao(diaBan, viTriVuKhuc, saoVuKhuc)

  const vitriThaiDuong = dichCung(viTriTuVi, 9)
  diaBan.nhapSao(diaBan, vitriThaiDuong, saoThaiDuong)

  const viTriThienCo = dichCung(viTriTuVi, 11)
  diaBan.nhapSao(diaBan, viTriThienCo, saoThienCo)

  // Thiên phủ tinh hệ
  // viTriTuVi = 4
  const viTriThienPhu = dichCung(3, 3 - viTriTuVi)
  diaBan.nhapSao(diaBan, viTriThienPhu, saoThienPhu)

  const viTriThaiAm = dichCung(viTriThienPhu, 1)
  diaBan.nhapSao(diaBan, viTriThaiAm, saoThaiAm)

  const viTriThamLang = dichCung(viTriThienPhu, 2)
  diaBan.nhapSao(diaBan, viTriThamLang, saoThamLang)

  const viTriCuMon = dichCung(viTriThienPhu, 3)
  diaBan.nhapSao(diaBan, viTriCuMon, saoCuMon)

  const viTriThienTuong = dichCung(viTriThienPhu, 4)
  diaBan.nhapSao(diaBan, viTriThienTuong, saoThienTuong)

  const viTriThienLuong = dichCung(viTriThienPhu, 5)
  diaBan.nhapSao(diaBan, viTriThienLuong, saoThienLuong)

  const viTriThatSat = dichCung(viTriThienPhu, 6)
  diaBan.nhapSao(diaBan, viTriThatSat, saoThatSat)

  const viTriPhaQuan = dichCung(viTriThienPhu, 10)
  diaBan.nhapSao(diaBan, viTriPhaQuan, saoPhaQuan)

  // Trung tinh
  const viTriVanKhuc = dichCung(5, gioSinh - 1)
  diaBan.nhapSao(diaBan, viTriVanKhuc, saoVanKhuc)

  const viTriVanXuong = dichCung(2, 2 - viTriVanKhuc)
  diaBan.nhapSao(diaBan, viTriVanXuong, saoVanXuong)

  const viTriTaPhu = dichCung(5, month - 1)
  diaBan.nhapSao(diaBan, viTriTaPhu, saoTaPhu)

  const viTriHuuBat = dichCung(2, 2 - viTriTaPhu)
  diaBan.nhapSao(diaBan, viTriHuuBat, saoHuuBat)

  //  Tứ Hóa
  // An theo 10 câu của cụ Thiên Lương trong cuốn
  // Số tử vi dưới mắt khoa học
  let viTriHoaLoc, viTriHoaQuyen, viTriHoaKhoa, viTriHoaKy

  switch (canNam) {
    case 1:
      viTriHoaLoc = viTriLiemTrinh
      viTriHoaQuyen = viTriPhaQuan
      viTriHoaKhoa = viTriVuKhuc
      viTriHoaKy = vitriThaiDuong
      break
    case 2:
      viTriHoaLoc = viTriThienCo
      viTriHoaQuyen = viTriThienLuong
      viTriHoaKhoa = viTriTuVi
      viTriHoaKy = viTriThaiAm
      break
    case 3:
      viTriHoaLoc = viTriThienDong
      viTriHoaQuyen = viTriThienCo
      viTriHoaKhoa = viTriVanXuong
      viTriHoaKy = viTriLiemTrinh
      break
    case 4:
      viTriHoaLoc = viTriThaiAm
      viTriHoaQuyen = viTriThienDong
      viTriHoaKhoa = viTriThienCo
      viTriHoaKy = viTriCuMon
      break
    case 5:
      viTriHoaLoc = viTriThamLang
      viTriHoaQuyen = viTriThaiAm
      viTriHoaKhoa = viTriHuuBat
      viTriHoaKy = viTriThienCo
      break
    case 6:
      viTriHoaLoc = viTriVuKhuc
      viTriHoaQuyen = viTriThamLang
      viTriHoaKhoa = viTriThienLuong
      viTriHoaKy = viTriVanKhuc
      break
    case 7:
      viTriHoaLoc = vitriThaiDuong
      viTriHoaQuyen = viTriVuKhuc
      viTriHoaKhoa = viTriThaiAm
      viTriHoaKy = viTriThienDong
      break
    case 8:
      viTriHoaLoc = viTriCuMon
      viTriHoaQuyen = vitriThaiDuong
      viTriHoaKhoa = viTriVanKhuc
      viTriHoaKy = viTriVanXuong
      break
    case 9:
      viTriHoaLoc = viTriThienLuong
      viTriHoaQuyen = viTriTuVi
      viTriHoaKhoa = viTriThienPhu
      viTriHoaKy = viTriVuKhuc
      break
    case 10:
      viTriHoaLoc = viTriPhaQuan
      viTriHoaQuyen = viTriCuMon
      viTriHoaKhoa = viTriThaiAm
      viTriHoaKy = viTriThamLang
      break
  }

  diaBan.nhapSao(diaBan, viTriHoaLoc, saoHoaLoc)
  diaBan.nhapSao(diaBan, viTriHoaQuyen, saoHoaQuyen)
  diaBan.nhapSao(diaBan, viTriHoaKhoa, saoHoaKhoa)
  diaBan.nhapSao(diaBan, viTriHoaKy, saoHoaKy)

  // Trung tinh
  const viTriThienKhoi = timThienKhoi(canNam)
  diaBan.nhapSao(diaBan, viTriThienKhoi, saoThienKhoi)

  const viTriThienViet = dichCung(5, 5 - viTriThienKhoi)
  diaBan.nhapSao(diaBan, viTriThienViet, saoThienViet)

  //  Không - Kiếp
  // Khởi giờ Tý ở cung Hợi, đếm thuận đến giờ sinh được cung Địa kiếp
  const viTriDiaKiep = dichCung(11, gioSinh)
  diaBan.nhapSao(diaBan, viTriDiaKiep, saoDiaKiep)

  const viTriDiaKhong = dichCung(12, 12 - viTriDiaKiep)
  diaBan.nhapSao(diaBan, viTriDiaKhong, saoDiaKhong)

  // Vị trí sao Lộc tồn ở Can của năm sinh trên địa bàn
  const viTriLocTon = thienCan[canNam].vitriDiaBan
  diaBan.nhapSao(diaBan, viTriLocTon, saoLocTon)

  //  Kình dương - Đà la
  const viTriDaLa = dichCung(viTriLocTon, -1)
  diaBan.nhapSao(diaBan, viTriDaLa, saoDaLa)

  const viTriKinhDuong = dichCung(viTriLocTon, 1)
  diaBan.nhapSao(diaBan, viTriKinhDuong, saoKinhDuong)

  const [viTriHoaTinh, viTriLinhTinh] = timHoaLinh(chiNam, gioSinh, gioiTinh, amDuongNamSinh)
  diaBan.nhapSao(diaBan, viTriHoaTinh, saoHoaTinh)
  diaBan.nhapSao(diaBan, viTriLinhTinh, saoLinhTinh)

  // Thiên mã
  const viTriThienMa = timThienMa(chiNam)
  diaBan.nhapSao(diaBan, viTriThienMa, saoThienMa)

  // An sao đôi
  const viTriLongTri = dichCung(5, chiNam - 1)
  diaBan.nhapSao(diaBan, viTriLongTri, saoLongTri)

  const viTriPhuongCac = dichCung(2, 2 - viTriLongTri)
  diaBan.nhapSao(diaBan, viTriPhuongCac, saoPhuongCac, saoGiaiThan)

  const viTriTamThai = dichCung(5, month + day - 2)
  diaBan.nhapSao(diaBan, viTriTamThai, saoTamThai)

  const viTriBatToa = dichCung(2, 2 - viTriTamThai)
  diaBan.nhapSao(diaBan, viTriBatToa, saoBatToa)

  const amDuongNamNu = gioiTinh * amDuongNamSinh

  //  Vòng ngũ hành cục Tràng sinh
  // !!! Đã sửa !!! *LƯU Ý Phần này đã sửa* Theo cụ Thiên Lương: Nam -> Thuận,
  // Nữ -> Nghịch (Không phù hợp)
  // **ISSUE 2**: Dương nam, Âm nữ theo chiều thuận, Âm nam Dương nữ theo
  // chiều nghịch

  const viTriTrangSinh = timTrangSinh(cucSo)
  diaBan.nhapSao(diaBan, viTriTrangSinh, saoTrangSinh)

  const viTriMocDuc = dichCung(viTriTrangSinh, amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriMocDuc, saoMocDuc)

  const viTriQuanDoi = dichCung(viTriTrangSinh, amDuongNamNu * 2)
  diaBan.nhapSao(diaBan, viTriQuanDoi, saoQuanDoi)

  const viTriLamQuan = dichCung(viTriTrangSinh, amDuongNamNu * 3)
  diaBan.nhapSao(diaBan, viTriLamQuan, saoLamQuan)

  const viTriDeVuong = dichCung(viTriTrangSinh, amDuongNamNu * 4)
  diaBan.nhapSao(diaBan, viTriDeVuong, saoDeVuong)

  const viTriSuy = dichCung(viTriTrangSinh, amDuongNamNu * 5)
  diaBan.nhapSao(diaBan, viTriSuy, saoSuy)

  const viTriBenh = dichCung(viTriTrangSinh, amDuongNamNu * 6)
  diaBan.nhapSao(diaBan, viTriBenh, saoBenh)

  const viTriTu = dichCung(viTriTrangSinh, amDuongNamNu * 7)
  diaBan.nhapSao(diaBan, viTriTu, saoTu)

  const viTriMo = dichCung(viTriTrangSinh, amDuongNamNu * 8)
  diaBan.nhapSao(diaBan, viTriMo, saoMo)

  const viTriTuyet = dichCung(viTriTrangSinh, amDuongNamNu * 9)
  diaBan.nhapSao(diaBan, viTriTuyet, saoTuyet)

  const viTriThai = dichCung(viTriTrangSinh, amDuongNamNu * (-2))
  diaBan.nhapSao(diaBan, viTriThai, saoThai)

  const viTriDuong = dichCung(viTriTrangSinh, amDuongNamNu * (-1))
  diaBan.nhapSao(diaBan, viTriDuong, saoDuong)

  // ! Vị trí sao Ân Quang - Thiên Quý
  // ! Lấy cung thìn làm mồng 1 đếm thuận đến ngày sinh,
  // ! lui lại một cung để lấy đó làm giờ tý đếm thuận đến giờ sinh là
  //  Ân Quang
  // ! Thiên Quý đối với Ân Quang qua trục Sửu Mùi
  // @ viTriAnQuang = dichCung(5, nn + gioSinh - 3)
  // @ viTriThienQuy = dichCung(2, 2 - viTriAnQuang)
  // Phía trên là cách an Quang-Quý theo cụ Vu Thiên
  // Sau khi tìm hiểu thì Quang-Quý sẽ được an theo Xương-Khúc như sau:
  // Ân Quang − Xem Văn Xương ở cung nào, kể cung ấy là mồng một
  // bắt đầu đếm thoe chiều thuận đến ngày sinh, lùi lại một cung,
  // an Ân Quang.
  // Thiên Quý − Xem Văn Khúc ở cung nào, kể cung ấy là mồng một,
  // !!! bắt đầu đếm theo chiều nghịch đến ngày sinh, lùi lại một cung,
  // an Thiên Quý.!!!
  // ??? Thiên Quý ở đối cung của Ân Quang qua trục Sửu Mùi mới chính xác???

  const viTriAnQuang = dichCung(viTriVanXuong, day - 2)
  diaBan.nhapSao(diaBan, viTriAnQuang, saoAnQuang)

  const viTriThienQuy = dichCung(2, 2 - viTriAnQuang)
  diaBan.nhapSao(diaBan, viTriThienQuy, saoThienQuy)

  const viTriThienHu = dichCung(7, chiNam - 1)
  diaBan.nhapSao(diaBan, viTriThienHu, saoThienHu)

  const viTriThienKhoc = dichCung(7, -chiNam + 1)
  diaBan.nhapSao(diaBan, viTriThienKhoc, saoThienKhoc)

  const viTriThienTai = dichCung(diaBan.cungMenh, chiNam - 1)
  diaBan.nhapSao(diaBan, viTriThienTai, saoThienTai)

  const viTriHongLoan = dichCung(4, -chiNam + 1)
  diaBan.nhapSao(diaBan, viTriHongLoan, saoHongLoan)

  const viTriThienHy = dichCung(viTriHongLoan, 6)
  diaBan.nhapSao(diaBan, viTriThienHy, saoThienHy)

  const viTriThienTho = dichCung(diaBan.cungThan, chiNam - 1)
  diaBan.nhapSao(diaBan, viTriThienTho, saoThienTho)

  //  Thiên Quan - Thiên Phúc
  const [viTriThienQuan, viTriThienPhuc] = timThienQuanThienPhuc(canNam)
  diaBan.nhapSao(diaBan, viTriThienQuan, saoThienQuan)
  diaBan.nhapSao(diaBan, viTriThienPhuc, saoThienPhuc)

  const viTriThienHinh = dichCung(10, month - 1)
  diaBan.nhapSao(diaBan, viTriThienHinh, saoThienHinh)

  const viTriThienRieu = dichCung(viTriThienHinh, 4)
  diaBan.nhapSao(diaBan, viTriThienRieu, saoThienRieu, saoThienY)

  // Thiên la - Địa võng, Thiên thương - Thiên sứ
  const viTriThienLa = 5
  diaBan.nhapSao(diaBan, viTriThienLa, saoThienLa)

  const viTriDiaVong = 11
  diaBan.nhapSao(diaBan, viTriDiaVong, saoDiaVong)

  const viTriThienThuong = diaBan.cungNoboc
  diaBan.nhapSao(diaBan, viTriThienThuong, saoThienThuong)

  const viTriThienSu = diaBan.cungTatAch
  diaBan.nhapSao(diaBan, viTriThienSu, saoThienSu)

  const viTriCoThan = timCoThan(chiNam)
  diaBan.nhapSao(diaBan, viTriCoThan, saoCoThan)

  const viTriQuaTu = dichCung(viTriCoThan, -4)
  diaBan.nhapSao(diaBan, viTriQuaTu, saoQuaTu)

  const viTriVanTinh = dichCung(viTriKinhDuong, 2)
  diaBan.nhapSao(diaBan, viTriVanTinh, saoVanTinh)

  const viTriDuongPhu = dichCung(viTriVanTinh, 2)
  diaBan.nhapSao(diaBan, viTriDuongPhu, saoDuongPhu)

  const viTriQuocAn = dichCung(viTriDuongPhu, 3)
  diaBan.nhapSao(diaBan, viTriQuocAn, saoQuocAn)

  // Thai phụ - Phong Cáo
  const viTriThaiPhu = dichCung(viTriVanKhuc, 2)
  diaBan.nhapSao(diaBan, viTriThaiPhu, saoThaiPhu)

  const viTriPhongCao = dichCung(viTriVanKhuc, -2)
  diaBan.nhapSao(diaBan, viTriPhongCao, saoPhongCao)

  // Thiên giải - Địa giải
  //    Theo cụ Thiên Lương: Lấy cung Thân làm tháng Giêng, đếm thuận nhưng
  //    nhảy cung là Thiên giải. Một số trang web đếm nhưng không nhảy cung???
  //    Liệu phương cách nào đúng?
  const viTriThienGiai = dichCung(9, month - 1)
  diaBan.nhapSao(diaBan, viTriThienGiai, saoThienGiai)

  const viTriDiaGiai = dichCung(viTriTaPhu, 3)
  diaBan.nhapSao(diaBan, viTriDiaGiai, saoDiaGiai)

  // Vòng Thiên mã
  const viTriHoaCai = dichCung(viTriThienMa, 2)
  diaBan.nhapSao(diaBan, viTriHoaCai, saoHoaCai)

  const viTriKiepSat = dichCung(viTriThienMa, 3)
  diaBan.nhapSao(diaBan, viTriKiepSat, saoKiepSat)

  const viTriDaoHoa = dichCung(viTriKiepSat, 4)
  diaBan.nhapSao(diaBan, viTriDaoHoa, saoDaoHoa)

  // Vòng Địa chi - Thái tuế
  const viTriThaiTue = chiNam
  diaBan.nhapSao(diaBan, viTriThaiTue, saoThaiTue)

  const viTriThieuDuong = dichCung(viTriThaiTue, 1)
  diaBan.nhapSao(diaBan, viTriThieuDuong, saoThieuDuong, saoThienKhong)

  //  An Lưu Hà - Thiên Trù
  // Sách cụ Thiên Lương không đề cập đến 2 sao này
  // Mong mọi người kiểm chứng
  const [viTriLuuHa, viTriThienTru] = timLuuTru(canNam)
  diaBan.nhapSao(diaBan, viTriLuuHa, saoLuuHa)
  diaBan.nhapSao(diaBan, viTriThienTru, saoThienTru)

  // Vòng Địa chi - Thái tuế
  const viTriTangMon = dichCung(viTriThaiTue, 2)
  diaBan.nhapSao(diaBan, viTriTangMon, saoTangMon)

  const viTriThieuAm = dichCung(viTriThaiTue, 3)
  diaBan.nhapSao(diaBan, viTriThieuAm, saoThieuAm)

  const viTriQuanPhu3 = dichCung(viTriThaiTue, 4)
  diaBan.nhapSao(diaBan, viTriQuanPhu3, saoQuanPhu3)

  const viTriTuPhu = dichCung(viTriThaiTue, 5)
  diaBan.nhapSao(diaBan, viTriTuPhu, saoTuPhu, saoNguyetDuc)

  const viTriTuePha = dichCung(viTriThaiTue, 6)
  diaBan.nhapSao(diaBan, viTriTuePha, saoTuePha)

  const viTriLongDuc = dichCung(viTriThaiTue, 7)
  diaBan.nhapSao(diaBan, viTriLongDuc, saoLongDuc)

  const viTriBachHo = dichCung(viTriThaiTue, 8)
  diaBan.nhapSao(diaBan, viTriBachHo, saoBachHo)

  const viTriPhucDuc = dichCung(viTriThaiTue, 9)
  diaBan.nhapSao(diaBan, viTriPhucDuc, saoThienDuc, saoPhucDuc)

  const viTriDieuKhach = dichCung(viTriThaiTue, 10)
  diaBan.nhapSao(diaBan, viTriDieuKhach, saoDieuKhach)

  const viTriTrucPhu = dichCung(viTriThaiTue, 11)
  diaBan.nhapSao(diaBan, viTriTrucPhu, saoTrucPhu)

  // Đẩu quân
  const viTriDauQuan = dichCung(chiNam, -month + gioSinh)
  diaBan.nhapSao(diaBan, viTriDauQuan, saoDauQuan)

  // Phá toái
  const viTriPhaToai = timPhaToai(chiNam)
  diaBan.nhapSao(diaBan, viTriPhaToai, saoPhaToai)

  // Vòng Lộc tồn
  //  sao Bác sỹ ở cùng cung với Lộc tồn
  diaBan.nhapSao(diaBan, viTriLocTon, saoBacSy)

  const viTriLucSi = dichCung(viTriLocTon, amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriLucSi, saoLucSi)

  const viTriThanhLong = dichCung(viTriLocTon, 2 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriThanhLong, saoThanhLong)

  const viTriTieuHao = dichCung(viTriLocTon, 3 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriTieuHao, saoTieuHao)

  const viTriTuongQuan = dichCung(viTriLocTon, 4 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriTuongQuan, saoTuongQuan)

  const viTriTauThu = dichCung(viTriLocTon, 5 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriTauThu, saoTauThu)

  const viTriPhiLiem = dichCung(viTriLocTon, 6 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriPhiLiem, saoPhiLiem)

  const viTriHyThan = dichCung(viTriLocTon, 7 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriHyThan, saoHyThan)

  const viTriBenhPhu = dichCung(viTriLocTon, 8 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriBenhPhu, saoBenhPhu)

  const viTriDaiHao = dichCung(viTriLocTon, 9 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriDaiHao, saoDaiHao)

  const viTriPhucBinh = dichCung(viTriLocTon, 10 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriPhucBinh, saoPhucBinh)

  const viTriQuanPhu2 = dichCung(viTriLocTon, 11 * amDuongNamNu)
  diaBan.nhapSao(diaBan, viTriQuanPhu2, saoQuanPhu2)

  // An sao luu
  //  Tứ Hóa
  // An theo 10 câu của cụ Thiên Lương trong cuốn
  // Số tử vi dưới mắt khoa học
  let viTriLHoaLoc, viTriLHoaQuyen, viTriLHoaKhoa, viTriLHoaKy

  let canLuuNamXem = canNamXem
  let chiLuuNamXem = chiNamXem
  if (tuHoaTv) {
    const tuHoaTvYear = Number(tuHoaTv.split('_')[0])
    const [tuHoaTvYearCan, tuHoaTvYearChi] = getYearCanChi(tuHoaTvYear).split(' ')
    canLuuNamXem = CAN.findIndex((item) => item === tuHoaTvYearCan) + 1
    chiLuuNamXem = CHI.findIndex((item) => item === tuHoaTvYearChi) + 1
  }
  switch (canLuuNamXem) {
    case 1:
      viTriLHoaLoc = viTriLiemTrinh
      viTriLHoaQuyen = viTriPhaQuan
      viTriLHoaKhoa = viTriVuKhuc
      viTriLHoaKy = vitriThaiDuong
      break
    case 2:
      viTriLHoaLoc = viTriThienCo
      viTriLHoaQuyen = viTriThienLuong
      viTriLHoaKhoa = viTriTuVi
      viTriLHoaKy = viTriThaiAm
      break
    case 3:
      viTriLHoaLoc = viTriThienDong
      viTriLHoaQuyen = viTriThienCo
      viTriLHoaKhoa = viTriVanXuong
      viTriLHoaKy = viTriLiemTrinh
      break
    case 4:
      viTriLHoaLoc = viTriThaiAm
      viTriLHoaQuyen = viTriThienDong
      viTriLHoaKhoa = viTriThienCo
      viTriLHoaKy = viTriCuMon
      break
    case 5:
      viTriLHoaLoc = viTriThamLang
      viTriLHoaQuyen = viTriThaiAm
      viTriLHoaKhoa = viTriHuuBat
      viTriLHoaKy = viTriThienCo
      break
    case 6:
      viTriLHoaLoc = viTriVuKhuc
      viTriLHoaQuyen = viTriThamLang
      viTriLHoaKhoa = viTriThienLuong
      viTriLHoaKy = viTriVanKhuc
      break
    case 7:
      viTriLHoaLoc = vitriThaiDuong
      viTriLHoaQuyen = viTriVuKhuc
      viTriLHoaKhoa = viTriThaiAm
      viTriLHoaKy = viTriThienDong
      break
    case 8:
      viTriLHoaLoc = viTriCuMon
      viTriLHoaQuyen = vitriThaiDuong
      viTriLHoaKhoa = viTriVanKhuc
      viTriLHoaKy = viTriVanXuong
      break
    case 9:
      viTriLHoaLoc = viTriThienLuong
      viTriLHoaQuyen = viTriTuVi
      viTriLHoaKhoa = viTriThienPhu
      viTriLHoaKy = viTriVuKhuc
      break
    case 10:
      viTriLHoaLoc = viTriPhaQuan
      viTriLHoaQuyen = viTriCuMon
      viTriLHoaKhoa = viTriThaiAm
      viTriLHoaKy = viTriThamLang
      break
  }

  diaBan.nhapSao(diaBan, viTriLHoaLoc, saoLuuHoaLoc)
  diaBan.nhapSao(diaBan, viTriLHoaQuyen, saoLuuHoaQuyen)
  diaBan.nhapSao(diaBan, viTriLHoaKhoa, saoLuuHoaKhoa)
  diaBan.nhapSao(diaBan, viTriLHoaKy, saoLuuHoaKy)

  const viTriLLocTon = thienCan[canNamXem].vitriDiaBan
  diaBan.nhapSao(diaBan, viTriLLocTon, saoLuuLocTon)

  const viTriLDaLa = dichCung(viTriLLocTon, -1)
  diaBan.nhapSao(diaBan, viTriLDaLa, saoLuuDaLa)

  const viTriLKinhDuong = dichCung(viTriLLocTon, 1)
  diaBan.nhapSao(diaBan, viTriLKinhDuong, saoLuuKinhDuong)

  const viTriLThienKhoi = timThienKhoi(canLuuNamXem)
  diaBan.nhapSao(diaBan, viTriLThienKhoi, saoLuuThienViet)

  const viTriLThienViet = dichCung(5, 5 - viTriLThienKhoi)
  diaBan.nhapSao(diaBan, viTriLThienViet, saoLuuThienKhoi)

  const viTriLThienMa = timThienMa(chiLuuNamXem)
  diaBan.nhapSao(diaBan, viTriLThienMa, saoLuuThienMa)

  const viTriLThaiTue = chiLuuNamXem
  diaBan.nhapSao(diaBan, viTriLThaiTue, saoLuuThaiTue)

  const viTriLTangMon = dichCung(viTriLThaiTue, 2)
  diaBan.nhapSao(diaBan, viTriLTangMon, saoLuuTangMon)

  const viTriLBachHo = dichCung(viTriLThaiTue, 8)
  diaBan.nhapSao(diaBan, viTriLBachHo, saoLuuBachHo)

  const viTriLThienHu = dichCung(7, chiLuuNamXem - 1)
  diaBan.nhapSao(diaBan, viTriLThienHu, saoLuuThienHu)

  const viTriTLhienKhoc = dichCung(7, -chiLuuNamXem + 1)
  diaBan.nhapSao(diaBan, viTriTLhienKhoc, saoLuuThienKhoc)

  // An sao luu
  //  Tứ Hóa theo dai van
  let viTriDvHoaLoc, viTriDvHoaQuyen, viTriDvHoaKhoa, viTriDvHoaKy

  if (tuHoaDv) {
    const curSoDaiHan = diaBan.curSoDaiHan
    const cungDaiVanXem = diaBan.thapNhiCung[tuHoaDv ?? curSoDaiHan]
    const canDvXem = cungDaiVanXem.cungCanId
    const chiDvXem = cungDaiVanXem.cungSo

    switch (canDvXem) {
      case 1:
        viTriDvHoaLoc = viTriLiemTrinh
        viTriDvHoaQuyen = viTriPhaQuan
        viTriDvHoaKhoa = viTriVuKhuc
        viTriDvHoaKy = vitriThaiDuong
        break
      case 2:
        viTriDvHoaLoc = viTriThienCo
        viTriDvHoaQuyen = viTriThienLuong
        viTriDvHoaKhoa = viTriTuVi
        viTriDvHoaKy = viTriThaiAm
        break
      case 3:
        viTriDvHoaLoc = viTriThienDong
        viTriDvHoaQuyen = viTriThienCo
        viTriDvHoaKhoa = viTriVanXuong
        viTriDvHoaKy = viTriLiemTrinh
        break
      case 4:
        viTriDvHoaLoc = viTriThaiAm
        viTriDvHoaQuyen = viTriThienDong
        viTriDvHoaKhoa = viTriThienCo
        viTriDvHoaKy = viTriCuMon
        break
      case 5:
        viTriDvHoaLoc = viTriThamLang
        viTriDvHoaQuyen = viTriThaiAm
        viTriDvHoaKhoa = viTriHuuBat
        viTriDvHoaKy = viTriThienCo
        break
      case 6:
        viTriDvHoaLoc = viTriVuKhuc
        viTriDvHoaQuyen = viTriThamLang
        viTriDvHoaKhoa = viTriThienLuong
        viTriDvHoaKy = viTriVanKhuc
        break
      case 7:
        viTriDvHoaLoc = vitriThaiDuong
        viTriDvHoaQuyen = viTriVuKhuc
        viTriDvHoaKhoa = viTriThaiAm
        viTriDvHoaKy = viTriThienDong
        break
      case 8:
        viTriDvHoaLoc = viTriCuMon
        viTriDvHoaQuyen = vitriThaiDuong
        viTriDvHoaKhoa = viTriVanKhuc
        viTriDvHoaKy = viTriVanXuong
        break
      case 9:
        viTriDvHoaLoc = viTriThienLuong
        viTriDvHoaQuyen = viTriTuVi
        viTriDvHoaKhoa = viTriThienPhu
        viTriDvHoaKy = viTriVuKhuc
        break
      case 10:
        viTriDvHoaLoc = viTriPhaQuan
        viTriDvHoaQuyen = viTriCuMon
        viTriDvHoaKhoa = viTriThaiAm
        viTriDvHoaKy = viTriThamLang
        break
    }

    diaBan.nhapSao(diaBan, viTriDvHoaLoc, saoDvHoaLoc)
    diaBan.nhapSao(diaBan, viTriDvHoaQuyen, saoDvHoaQuyen)
    diaBan.nhapSao(diaBan, viTriDvHoaKhoa, saoDvHoaKhoa)
    diaBan.nhapSao(diaBan, viTriDvHoaKy, saoDvHoaKy)

    const viTriDvLocTon = thienCan[canDvXem].vitriDiaBan
    diaBan.nhapSao(diaBan, viTriDvLocTon, saoDvLocTon)

    const viTriDvDaLa = dichCung(viTriDvLocTon, -1)
    diaBan.nhapSao(diaBan, viTriDvDaLa, saoDvDaLa)

    const viTriDvKinhDuong = dichCung(viTriDvLocTon, 1)
    diaBan.nhapSao(diaBan, viTriDvKinhDuong, saoDvKinhDuong)

    const viTriDvThienKhoi = timThienKhoi(canDvXem)
    diaBan.nhapSao(diaBan, viTriDvThienKhoi, saoDvThienViet)

    const viTriDvThienViet = dichCung(5, 5 - viTriDvThienKhoi)
    diaBan.nhapSao(diaBan, viTriDvThienViet, saoDvThienKhoi)

    const viTriDvThienMa = timThienMa(chiDvXem)
    diaBan.nhapSao(diaBan, viTriDvThienMa, saoDvThienMa)

    const viTriDvThaiTue = chiDvXem
    diaBan.nhapSao(diaBan, viTriDvThaiTue, saoDvThaiTue)

    const viTriDvTangMon = dichCung(viTriDvThaiTue, 2)
    diaBan.nhapSao(diaBan, viTriDvTangMon, saoDvTangMon)

    const viTriDvBachHo = dichCung(viTriDvThaiTue, 8)
    diaBan.nhapSao(diaBan, viTriDvBachHo, saoDvBachHo)

    const viTriDvThienHu = dichCung(7, chiNamXem - 1)
    diaBan.nhapSao(diaBan, viTriDvThienHu, saoDvThienHu)

    const viTriDvThienKhoc = dichCung(7, -chiNamXem + 1)
    diaBan.nhapSao(diaBan, viTriDvThienKhoc, saoDvThienKhoc)
  }

  // An Tuần, Triệt
  const ketThucTuan = dichCung(chiNam, 10 - canNam)
  const viTriTuan1 = dichCung(ketThucTuan, 1)
  const viTriTuan2 = dichCung(viTriTuan1, 1)
  diaBan.nhapTuan(viTriTuan1, viTriTuan2)

  const [viTriTriet1, viTriTriet2] = timTriet(canNam)
  diaBan.nhapTriet(viTriTriet1, viTriTriet2)

  // An Tuần, Triệt theo dai van
  if (tuHoaDv) {
    const cungDaiVanXem1 = diaBan.thapNhiCung[tuHoaDv]
    const canDvXem1 = cungDaiVanXem1.cungCanId
    const chiDvXem1 = cungDaiVanXem1.cungSo

    const ketThucTuan1 = dichCung(chiDvXem1, 10 - canDvXem1)
    const viTriTuan11 = dichCung(ketThucTuan1, 1)
    const viTriTuan22 = dichCung(viTriTuan11, 1)
    diaBan.nhapTuanDv(viTriTuan11, viTriTuan22)

    const [viTriTriet11, viTriTriet22] = timTriet(canDvXem1)
    diaBan.nhapTrietDv(viTriTriet11, viTriTriet22)
  }

  // An cung phi
  const thapNhiCung = diaBan.thapNhiCung
  const dataTuHoa = []
  Object.values(thapNhiCung).forEach((item) => {
    if (item.cungSo) {
      let viTriCpHoaLoc, viTriCpHoaQuyen, viTriCpHoaKhoa, viTriCpHoaKy
      const cungSo = item.cungSo
      switch (item.cungCanId) {
        case 1:
          viTriCpHoaLoc = viTriLiemTrinh
          viTriCpHoaQuyen = viTriPhaQuan
          viTriCpHoaKhoa = viTriVuKhuc
          viTriCpHoaKy = vitriThaiDuong
          break
        case 2:
          viTriCpHoaLoc = viTriThienCo
          viTriCpHoaQuyen = viTriThienLuong
          viTriCpHoaKhoa = viTriTuVi
          viTriCpHoaKy = viTriThaiAm
          break
        case 3:
          viTriCpHoaLoc = viTriThienDong
          viTriCpHoaQuyen = viTriThienCo
          viTriCpHoaKhoa = viTriVanXuong
          viTriCpHoaKy = viTriLiemTrinh
          break
        case 4:
          viTriCpHoaLoc = viTriThaiAm
          viTriCpHoaQuyen = viTriThienDong
          viTriCpHoaKhoa = viTriThienCo
          viTriCpHoaKy = viTriCuMon
          break
        case 5:
          viTriCpHoaLoc = viTriThamLang
          viTriCpHoaQuyen = viTriThaiAm
          viTriCpHoaKhoa = viTriHuuBat
          viTriCpHoaKy = viTriThienCo
          break
        case 6:
          viTriCpHoaLoc = viTriVuKhuc
          viTriCpHoaQuyen = viTriThamLang
          viTriCpHoaKhoa = viTriThienLuong
          viTriCpHoaKy = viTriVanKhuc
          break
        case 7:
          viTriCpHoaLoc = vitriThaiDuong
          viTriCpHoaQuyen = viTriVuKhuc
          viTriCpHoaKhoa = viTriThaiAm
          viTriCpHoaKy = viTriThienDong
          break
        case 8:
          viTriCpHoaLoc = viTriCuMon
          viTriCpHoaQuyen = vitriThaiDuong
          viTriCpHoaKhoa = viTriVanKhuc
          viTriCpHoaKy = viTriVanXuong
          break
        case 9:
          viTriCpHoaLoc = viTriThienLuong
          viTriCpHoaQuyen = viTriTuVi
          viTriCpHoaKhoa = viTriThienPhu
          viTriCpHoaKy = viTriVuKhuc
          break
        case 10:
          viTriCpHoaLoc = viTriPhaQuan
          viTriCpHoaQuyen = viTriCuMon
          viTriCpHoaKhoa = viTriThaiAm
          viTriCpHoaKy = viTriThamLang
          break
      }

      dataTuHoa.push([cungSo, viTriCpHoaLoc, viTriCpHoaQuyen, viTriCpHoaKhoa, viTriCpHoaKy])

      diaBan.nhapTuHoa(diaBan, cungSo, { ...saoHoaLoc, viTriCp: thapNhiCung[viTriCpHoaLoc].cungChuShort })
      diaBan.nhapTuHoa(diaBan, cungSo, { ...saoHoaQuyen, viTriCp: thapNhiCung[viTriCpHoaQuyen].cungChuShort })
      diaBan.nhapTuHoa(diaBan, cungSo, { ...saoHoaKhoa, viTriCp: thapNhiCung[viTriCpHoaKhoa].cungChuShort })
      diaBan.nhapTuHoa(diaBan, cungSo, { ...saoHoaKy, viTriCp: thapNhiCung[viTriCpHoaKy].cungChuShort })

      diaBan.nhapTuHoa2(diaBan, viTriCpHoaLoc, { ...saoHoaLoc, viTriCp: item.cungChuShort })
      diaBan.nhapTuHoa2(diaBan, viTriCpHoaQuyen, { ...saoHoaQuyen, viTriCp: item.cungChuShort })
      diaBan.nhapTuHoa2(diaBan, viTriCpHoaKhoa, { ...saoHoaKhoa, viTriCp: item.cungChuShort })
      diaBan.nhapTuHoa2(diaBan, viTriCpHoaKy, { ...saoHoaKy, viTriCp: item.cungChuShort })
    }
  })

  const pathTuHoaLoc = []
  const pathTuHoaKy = []
  const pathTuHoaQuyen = []
  const pathTuHoaKhoa = []
  Object.values(thapNhiCung).forEach((item) => {
    const cungSo = item.cungSo

    // check truy cung
    const truyCung = [1, 2, 3, 4]
    const tmpTruyCung = [...truyCung]
    const tmpTruyCungKy = [...truyCung]
    const tmpTruyCungQuyen = [...truyCung]
    const tmpTruyCungKhoa = [...truyCung]

    const type = []
    const typeKy = []
    const typeQuyen = []
    const typeKhoa = []
    // check hoa loc
    if (item.cungChu === 'Mệnh') {
      type.push(2)
      typeKy.push(2)
      typeQuyen.push(2)
      typeKhoa.push(2)
    }
    if ([viTriHoaLoc].includes(item.cungSo)) {
      type.push(1)
    }

    if (dataTuHoa[cungSo - 1] && cungSo === dataTuHoa[cungSo - 1][1]) {
      type.push(3)
      typeQuyen.push(3)
      typeKhoa.push(3)
    }

    if ([viTriHoaKy].includes(item.cungSo)) {
      typeKy.push(1)
    }

    if ([viTriHoaQuyen].includes(item.cungSo)) {
      typeQuyen.push(1)
    }

    if ([viTriHoaKhoa].includes(item.cungSo)) {
      typeKhoa.push(1)
    }

    if (type.length || typeKy.length || typeQuyen.length || typeKhoa.length) {
      if (truyCung.includes(cungSo)) {
        type.push(4)
        const idx = tmpTruyCung.indexOf(cungSo)
        if (idx !== -1) {
          tmpTruyCung.splice(idx, 1)
        }
        const idx2 = tmpTruyCungKy.indexOf(cungSo)
        if (idx2 !== -1) {
          tmpTruyCungKy.splice(idx2, 1)
        }
        const idx3 = tmpTruyCungQuyen.indexOf(cungSo)
        if (idx3 !== -1) {
          tmpTruyCungQuyen.splice(idx3, 1)
        }
        const idx4 = tmpTruyCungKhoa.indexOf(cungSo)
        if (idx4 !== -1) {
          tmpTruyCungKhoa.splice(idx4, 1)
        }
      }
      const [id, loc, quyen, khoa, ky] = dataTuHoa[cungSo - 1]
      if (type.length) {
        pathTuHoaLoc.push([id, loc, dataTuHoa[loc - 1][4], type])
      }
      if (typeKy.length) {
        pathTuHoaKy.push([id, ky, dataTuHoa[ky - 1][4], typeKy])
      }
      if (typeQuyen.length) {
        pathTuHoaQuyen.push([id, quyen, dataTuHoa[quyen - 1][3], typeQuyen])
      }
      if (typeKhoa.length) {
        pathTuHoaKhoa.push([id, khoa, dataTuHoa[khoa - 1][3], typeKhoa])
      }
    }

    if (tmpTruyCung.includes(cungSo)) {
      const [id, loc] = dataTuHoa[cungSo - 1]
      pathTuHoaLoc.push([id, loc, dataTuHoa[loc - 1][4], [4]])
    }
    if (tmpTruyCungKy.includes(cungSo)) {
      const [id] = dataTuHoa[cungSo - 1]
      const ky = dataTuHoa[cungSo - 1][4]
      pathTuHoaKy.push([id, ky, dataTuHoa[ky - 1][4], [4]])
    }
    if (tmpTruyCungQuyen.includes(cungSo)) {
      const [id] = dataTuHoa[cungSo - 1]
      const quyen = dataTuHoa[cungSo - 1][2]
      pathTuHoaQuyen.push([id, quyen, dataTuHoa[quyen - 1][3], [4]])
    }
    if (tmpTruyCungKhoa.includes(cungSo)) {
      const [id] = dataTuHoa[cungSo - 1]
      const khoa = dataTuHoa[cungSo - 1][3]
      pathTuHoaKhoa.push([id, khoa, dataTuHoa[khoa - 1][3], [4]])
    }

    if (dataTuHoa[cungSo - 1]) {
      const [id, loc, quyen, khoa, ky] = dataTuHoa[cungSo - 1]
      const checkExistLoc = pathTuHoaLoc.findIndex((item) => item[0] === id && item[1] === loc)
      if (checkExistLoc === -1) {
        pathTuHoaLoc.push([id, loc, null, [0]])
      }

      const checkExistKy = pathTuHoaKy.findIndex((item) => item[0] === id && item[1] === ky)
      if (checkExistKy === -1) {
        pathTuHoaKy.push([id, ky, null, [0]])
      }

      const checkExistQuyen = pathTuHoaQuyen.findIndex((item) => item[0] === id && item[1] === quyen)
      if (checkExistQuyen === -1) {
        pathTuHoaQuyen.push([id, quyen, null, [0]])
      }

      const checkExistKhoa = pathTuHoaKhoa.findIndex((item) => item[0] === id && item[1] === khoa)
      if (checkExistKhoa === -1) {
        pathTuHoaKhoa.push([id, khoa, null, [0]])
      }
    }
  })

  diaBan.nhapPathTuHoaLoc(pathTuHoaLoc)
  diaBan.nhapPathTuHoaKy(pathTuHoaKy)
  diaBan.nhapPathTuHoaQuyen(pathTuHoaQuyen)
  diaBan.nhapPathTuHoaKhoa(pathTuHoaKhoa)
  // console.log(pathTuHoaLoc)
  // console.log(pathTuHoaKy)

  const tuHoaTvCung = tuHoaTv ? Number(tuHoaTv.split('_')[1]) : null
  diaBan.nhapLineMenh(diaBan.cungMenh)
  diaBan.nhapLineMenhPhu(tuHoaTvCung ?? tuHoaDv)

  return diaBan
}
